module.exports = __webpack_public_path__ + "static/media/pro5.fee282d4.jpg";